import script from "./tagmanage.vue?vue&type=script&setup=true&lang=js"
export * from "./tagmanage.vue?vue&type=script&setup=true&lang=js"

import "./tagmanage.vue?vue&type=style&index=0&id=6cb3ff97&lang=scss"

const __exports__ = script;

export default __exports__